if (typeof $ !== 'undefined') {
  const $ = jQuery;
}

class MfiPromo {
  constructor() {
    this.mfipStyleIds = [842600, 842700, 842800, 849400];
    this.isEligible = this.isEligible.bind(this);

    if (this.isEligible()) {
      this.mfipStyleIds.forEach(function (mfipStyleId) {
        $(`[data-style-id=${mfipStyleId}]`).show();
      });
    }
  }

  isEligible() {
    if (ProductCatalog.IFrame.isFramed() || !$('.pc-Styles').length) {
      return false;
    }
    return true;
  }
}

ProductCatalog.MfiPromo = new MfiPromo();
